const styles = {
  boxWidth: "xl:max-w-[1280px] w-full",

  heading2:
    "font-Montserrat font-semibold text-white sm:text-[46px] sm:leading-[60px] xm:text-[31.5px] text-[24px] xm:leading-[44px] leading-[35px] w-full",
  paragraph:
    "font-Montserrat font-normal text-dimWhite text-[18px] leading-[30.8px]",

  flexCenter: "flex justify-center items-center",

  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-12 py-4",

  marginX: "sm:mx-16 mx-6",
  marginY: "sm:my-16 my-6",
};

export default styles;
